import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";

import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
import { 
  WalletTransferMutationMutation, 
  WalletTransferMutationMutationVariables 
} from "../../../../schemaTypes";

export const walletTransferMutation = gql`
  mutation WalletTransferMutation(
    $input: WalletTransferInput!
  ) {
    walletTransfer(
      input: $input
    ){
      errors {
        path
        message
      }
      message
      data {
        id
        account_number
        bank_code
        full_name
        currency
        debit_currency
        amount
        fee
        status
        reference
        narration 
        complete_message
        requires_approval
        is_approved
        bank_name
        created_at
      }
    }
  }
`;

interface Props {
  children: (
    data: {
      submitWalletTransfer: (
        values: WalletTransferMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      walletTransferData: any | null; 
    }
  ) => ReactElement | null;
}

export const WalletTransferController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    WalletTransferMutationMutation,
    WalletTransferMutationMutationVariables
  >(walletTransferMutation);

  const submitWalletTransfer = async (values: WalletTransferMutationMutationVariables) => {
    const { data: {walletTransfer} }:any = await mutate({ variables: values });

    if (walletTransfer?.errors) {
      return {error: normalizeErrors(walletTransfer.errors), walletTransfer: null};
    }

    return {
      error: null,
      walletTransfer
    };
  };

  const message = data?.walletTransfer?.message || null;
  return children({
    submitWalletTransfer,
    loading,
    error,
    message,
    walletTransferData: data,
  });
};